(function () {
  'use strict';

  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var isNormalizingCart = false;
  var isRefreshingCart = false;
  var refreshTimer = null;

  function getDrawerComponent() {
    return document.querySelector('cart-drawer-component');
  }

  function getSectionId(drawer) {
    var cartItems = drawer && drawer.querySelector('cart-items-component[data-section-id]');
    return cartItems && cartItems.getAttribute('data-section-id');
  }

  function isCartMutationUrl(url) {
    if (!url || typeof url !== 'string') return false;

    return /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url);
  }

  function isCartAddUrl(url) {
    return !!url && /\/cart\/add(\.js)?(?:\?|$)/.test(url);
  }

  function fetchCart() {
    if (!nativeFetch) return Promise.reject(new Error('Fetch unavailable'));

    return nativeFetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart fetch failed');
      return response.json();
    });
  }

  function fetchSection(sectionId) {
    if (!nativeFetch || !sectionId) return Promise.resolve({});

    var url = new URL(window.location.href);
    url.searchParams.set('sections', sectionId);
    url.searchParams.set('_', Date.now().toString());

    return nativeFetch(url.toString(), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart section fetch failed');
        return response.json();
      })
      .catch(function () {
        return {};
      });
  }

  function dispatchCartUpdate(cart, sectionId, sections) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'custom-cart-drawer',
        data: {
          itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : undefined,
          source: 'custom-cart-drawer',
          sections: sections || {}
        }
      }
    }));
  }

  function openDrawer() {
    var drawer = getDrawerComponent();

    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    var dialog = drawer && drawer.querySelector('dialog');
    if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
      dialog.showModal();
    }
  }

  function refreshCart(options) {
    options = options || {};

    if (isRefreshingCart) return Promise.resolve();

    var drawer = getDrawerComponent();
    var sectionId = getSectionId(drawer);
    var sectionsPromise = options.sections ? Promise.resolve(options.sections) : fetchSection(sectionId);

    isRefreshingCart = true;

    return Promise.all([fetchCart(), sectionsPromise])
      .then(function (results) {
        var cart = results[0];
        var sections = results[1] || {};

        dispatchCartUpdate(cart, sectionId, sections);

        if (options.open && cart && cart.item_count > 0) {
          window.setTimeout(openDrawer, 40);
        }

        return cart;
      })
      .catch(function () {})
      .finally(function () {
        isRefreshingCart = false;
      });
  }

  function queueCartRefresh(shouldOpen, sections) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      refreshCart({ open: shouldOpen, sections: sections });
    }, 140);
  }

  function postCartAdd(payload) {
    if (!nativeFetch) return Promise.reject(new Error('Fetch unavailable'));

    return nativeFetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Add failed');
      return response.json();
    });
  }

  function postCartChange(payload) {
    if (!nativeFetch) return Promise.reject(new Error('Fetch unavailable'));

    return nativeFetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Change failed');
      return response.json();
    });
  }

  function setButtonLoading(button, isLoading, text) {
    if (!button) return;
    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
    if (text != null) button.textContent = text;
  }

  function setSelectLoading(select, isLoading) {
    if (select) select.disabled = isLoading;
  }

  function patchFetchCartMutations() {
    if (!nativeFetch || window.__tvCartDrawerFetchPatched) return;

    window.__tvCartDrawerFetchPatched = true;

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var isCartMutation = isCartMutationUrl(url);
      var shouldOpen = isCartAddUrl(url);

      return nativeFetch(input, init).then(function (response) {
        if (isCartMutation && response && response.ok) {
          queueCartRefresh(shouldOpen);
        }

        return response;
      });
    };
  }

  function patchXhrCartMutations() {
    if (!window.XMLHttpRequest || window.__tvCartDrawerXhrPatched) return;

    window.__tvCartDrawerXhrPatched = true;

    var nativeOpen = window.XMLHttpRequest.prototype.open;
    var nativeSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__tvCartDrawerUrl = typeof url === 'string' ? url : '';
      return nativeOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      var url = xhr.__tvCartDrawerUrl;
      var isCartMutation = isCartMutationUrl(url);
      var shouldOpen = isCartAddUrl(url);

      if (isCartMutation) {
        xhr.addEventListener('loadend', function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            queueCartRefresh(shouldOpen);
          }
        }, { once: true });
      }

      return nativeSend.apply(xhr, arguments);
    };
  }

  patchFetchCartMutations();
  patchXhrCartMutations();

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('cart-drawer-component > .header-actions__action');
    if (!trigger) return;

    window.setTimeout(function () {
      refreshCart({ open: true });
    }, 0);
  }, true);

  document.addEventListener('cart:update', function (event) {
    if (isNormalizingCart || (event.detail && event.detail.data && typeof event.detail.data.itemCount === 'number')) {
      return;
    }

    isNormalizingCart = true;
    refreshCart({
      open: false,
      sections: event.detail && event.detail.data && event.detail.data.sections
    }).finally(function () {
      isNormalizingCart = false;
    });
  });

  document.addEventListener('click', function (event) {
    var checkoutButton = event.target.closest('.cart-drawer__summary .cart__checkout-button');
    if (!checkoutButton || checkoutButton.classList.contains('is-loading')) return;

    checkoutButton.classList.add('is-loading');
    checkoutButton.setAttribute('aria-busy', 'true');

    if (checkoutButton.tagName === 'BUTTON') {
      checkoutButton.disabled = true;
    }
  }, true);

  document.addEventListener('click', function (event) {
    var addBtn = event.target.closest('.tv-cart-rec__add-btn');
    if (!addBtn || addBtn.disabled) return;

    event.preventDefault();

    var drawer = getDrawerComponent();
    var sectionId = getSectionId(drawer);
    var item = addBtn.closest('.tv-cart-rec__item');
    var variantSelect = item && item.querySelector('.tv-cart-rec__variant-selector');
    var variantId = variantSelect ? variantSelect.value : addBtn.getAttribute('data-variant-id');
    var originalText = addBtn.textContent;

    if (!variantId) return;

    setButtonLoading(addBtn, true, '...');
    setSelectLoading(variantSelect, true);

    var payload = {
      id: parseInt(variantId, 10),
      quantity: 1
    };

    if (sectionId) {
      payload.sections = sectionId;
      payload.sections_url = window.location.pathname;
    }

    postCartAdd(payload)
      .then(function (response) {
        addBtn.textContent = 'OK';
        queueCartRefresh(true, response.sections);
      })
      .catch(function () {
        setButtonLoading(addBtn, false, originalText);
        setSelectLoading(variantSelect, false);
      });
  });

  document.addEventListener('change', function (event) {
    var variantSelect = event.target.closest('.tv-cart-item__variant-selector');
    if (!variantSelect || variantSelect.disabled) return;

    var drawer = getDrawerComponent();
    var sectionId = getSectionId(drawer);
    var oldKey = variantSelect.getAttribute('data-item-key');
    var newVariantId = parseInt(variantSelect.value, 10);
    var quantity = parseInt(variantSelect.getAttribute('data-current-quantity'), 10) || 1;

    if (!oldKey || !Number.isFinite(newVariantId)) return;

    setSelectLoading(variantSelect, true);

    postCartChange({ id: oldKey, quantity: 0 })
      .then(function () {
        var payload = {
          id: newVariantId,
          quantity: quantity
        };

        if (sectionId) {
          payload.sections = sectionId;
          payload.sections_url = window.location.pathname;
        }

        return postCartAdd(payload);
      })
      .then(function (response) {
        queueCartRefresh(true, response.sections);
      })
      .catch(function () {
        setSelectLoading(variantSelect, false);
      });
  });
})();
